import { inject } from '@angular/core';
import { Router, Routes, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './services/auth.service';

export const authGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isAuthenticated()) {
    return true;
  }
  const hasAuthParams = route.queryParamMap.has('phone') || route.queryParamMap.has('p') || route.queryParamMap.has('token');
  if (hasAuthParams) {
    return router.createUrlTree(['/login'], { queryParams: route.queryParams });
  }
  return router.parseUrl('/login');
};

export const guestGuard = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const hasAuthParams = route.queryParamMap.has('phone') || route.queryParamMap.has('p') || route.queryParamMap.has('token');
  if (auth.isAuthenticated() && !hasAuthParams) {
    return router.parseUrl('/main');
  }
  return true;
};

export const rootGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isAuthenticated()) {
    return router.parseUrl('/main');
  }
  const hasAuthParams = route.queryParamMap.has('phone') || route.queryParamMap.has('p') || route.queryParamMap.has('token');
  if (hasAuthParams) {
    return router.createUrlTree(['/login'], { queryParams: route.queryParams });
  }
  return router.parseUrl('/login');
};

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [rootGuard],
    children: [],
  },
  {
    path: 'main',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/main/main.page').then((m) => m.MainPage),
  },
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./pages/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'folder/:folder',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./folder/folder.page').then((m) => m.FolderPage),
  },
  {
    path: '**',
    canActivate: [rootGuard],
    children: [],
  },
];

